import React from "react";
import { styled } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";

import { Notifications } from "../Notifications";
import { COLOR_WHITE } from "../../constants/styles";
import { getStagingColor } from "../../constants/stagingconfig";
import { Grid } from "../../UI/Grid";
import { Toolbar } from "../../UI/Toolbar";
import { AppBar } from "../../UI/AppBar";
import { useHeaderContext } from "./context";
import { NetworkInput } from "./NetworkInput";
import { IconButton } from "../../UI/IconButton";
import useAuth from "../../routes/login/AuthContext";
import { MatchDatesStatusBanner } from "../MatchDatesStatusBanner";


const StyledAppBar = styled(AppBar)`
  background-color: ${getStagingColor()};
`;

export const Header = () => {
  const { isSuperAdmin } = useAuth();
  const { openNav, isNavOpen } = useHeaderContext();

  return (
    <>
      <StyledAppBar elevation={0} position="fixed" open={isNavOpen}>
        <MatchDatesStatusBanner />
        <Toolbar>
          <Grid
            container
            spacing={2}
            wrap="nowrap"
            alignItems="center"
            justifyContent="space-between"
          >
            {isNavOpen && <Grid item />}
            {!isNavOpen && (
              <Grid item>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  onClick={openNav}
                  edge="start"
                >
                  <MenuIcon htmlColor={COLOR_WHITE} />
                </IconButton>
              </Grid>
            )}
            <Grid item xs md={4}>
              <NetworkInput />
            </Grid>
            <Grid item>{isSuperAdmin() && <Notifications />}</Grid>
          </Grid>
        </Toolbar>
      </StyledAppBar>
    </>
  );
};
